import { useEffect } from "react";
import { useParams } from "react-router";

import { triggerLogin } from "authentication/actions";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { unauthenticate } from "domains/authentication/actions";
import { getIsAuthenticated } from "domains/authentication/selectors";
import { activateModal } from "domains/modal/actions";
import { getShouldDisplayNotifications } from "entities/permissions/selectors";

export const LoginOrRegisterEffect = () => {
  const dispatch = useDispatch();
  const go = useGo();
  const isAuthenticated = useSelector(getIsAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) dispatch(triggerLogin());
    go("/");
  }, [dispatch, go, isAuthenticated]);

  return null;
};

export const ResetPasswordLoginEffect = () => {
  const dispatch = useDispatch();
  const go = useGo();

  useEffect(() => {
    dispatch(triggerLogin());
    go("/");
  }, [dispatch, go]);

  return null;
};

export const NotificationsEffect = () => {
  const dispatch = useDispatch();
  const go = useGo();
  const { id } = useParams();
  const isAuthenticated = useSelector(getIsAuthenticated);
  const canAccessNotifications = useSelector(getShouldDisplayNotifications);

  useEffect(() => {
    if (!isAuthenticated) dispatch(triggerLogin());
    else if (canAccessNotifications) dispatch(activateModal({ id: "Notifications", params: { id } }));
    go("/");
  }, [canAccessNotifications, dispatch, go, id, isAuthenticated]);

  return null;
};

export const LogoutEffect = () => {
  const dispatch = useDispatch();
  const go = useGo();

  useEffect(() => {
    dispatch(unauthenticate({ isUserLogout: true }));
    go("/");
  }, [dispatch, go]);

  return null;
};

export const MapInviteLinkEffect = () => {
  const dispatch = useDispatch();
  const go = useGo();
  const { token } = useParams();
  const isAuthenticated = useSelector(getIsAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) dispatch(triggerLogin());
    else dispatch(activateModal({ id: "OpenLinkInvitation", params: { token } }));
    go("/");
  }, [dispatch, go, isAuthenticated, token]);

  return null;
};
